import merge from "lodash/merge";
import { compose, createStore, applyMiddleware } from "redux";
import { getLang } from "../reducers/crossword/selectors";
import {
  loadTranslations,
  setLocale,
  syncTranslationWithStore
} from "react-redux-i18n";
import thunk from "redux-thunk";
import persistState from "redux-localstorage";
import reducers from "../reducers";
import translations from "../translations";
import { VERSION } from "../constants";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  reducers,
  composeEnhancers(
    applyMiddleware(thunk),
    persistState(null, {
      key: `pp-${VERSION}`,
      paths: ["user", "crossword", "levels", "ui", "sound"],
      merge: (initialState, persistedState) =>
        merge({}, initialState, persistedState)
    })
  )
);

syncTranslationWithStore(store);
store.dispatch(loadTranslations(translations));
store.dispatch((dispatch, getState) =>
  dispatch(setLocale(getLang(getState())))
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js